import { createContext, useContext } from 'react';

/* Whether the tour is running, readable by any page it points at.

   The tour spotlights real UI, which means the page underneath has to
   hold still while it does. Two things went wrong without this:

     · The learn path collapses every section except the active one, and
       a collapsed row still exists — it is squashed to zero height by
       `grid-template-rows: 0fr`. The step that points at "your place on
       the path" therefore measured a 0px box, failed the sanity check,
       and fell back to a centred card explaining a node it never lit up.

     · Nothing stopped the reader collapsing that section mid-tour, which
       produced the same dead spotlight from the other direction.

   So the path asks whether a tour is running and, while one is, keeps
   the active section open and refuses to collapse it. */
export const TourContext = createContext(false);

export const useTourActive = () => useContext(TourContext);
